const STATUS_MAP = {
  bozza: { label: 'Bozza', className: 'mang-badge-warning' },
  inviata: { label: 'Inviata', className: 'mang-badge-info' },
  in_valutazione: { label: 'In valutazione', className: 'mang-badge-warning' },
  approvata: { label: 'Approvata', className: 'mang-badge-success' },
  approvato: { label: 'Approvato', className: 'mang-badge-success' },
  rifiutata: { label: 'Rifiutata', className: 'mang-badge-danger' },
  rifiutato: { label: 'Rifiutato', className: 'mang-badge-danger' },
  scartato: { label: 'Scartato', className: 'mang-badge-danger' },
  in_revisione: { label: 'In revisione', className: 'mang-badge-info' },
  candidato: { label: 'Candidato', className: 'mang-badge-info' },
  nuova: { label: 'Nuova', className: 'mang-badge-info' },
  in_gestione: { label: 'In gestione', className: 'mang-badge-warning' },
  chiusa: { label: 'Chiusa', className: 'mang-badge-success' },
  in_attesa: { label: 'In attesa', className: 'mang-badge-warning' },
  accettato: { label: 'Accettato', className: 'mang-badge-success' },
  rifiutato_ordine: { label: 'Rifiutato', className: 'mang-badge-danger' },
};

export function getStatusBadge(status) {
  return STATUS_MAP[status] || { label: status, className: 'mang-badge-info' };
}

export default STATUS_MAP;
